<template>
  <div id="quote-details">
    <div v-if="isBusy" class="d-flex align-items-center justify-content-center">
      <h2 class="p-5">
        <loading-spinner />
        Loading details for quote {{ quoteNumber }}...
      </h2>
    </div>
    <div v-else-if="notFound">
      <quote-not-found :quote-number="quoteNumber" />
    </div>
    <div v-else-if="showSendFailure" class="container">
      <send-error :error-message="errorMessage" />
    </div>
    <div v-else-if="showThankYou" class="container">
      <thank-you />
    </div>
    <div v-else-if="showForm" class="container">
      <convert-form :data="getFormData()" />
    </div>
    <div v-else class="container">
      <quote-header :data="getHeaderData()" />
      <quote-details-grid :details="getGridDetails()" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import { ErrorLogService, QuoteService } from "@/services";

  import QuoteNotFound from "./QuoteNotFound";
  import QuoteHeader from "./QuoteHeader";
  import QuoteDetailsGrid from "./QuoteDetailsGrid";
  import ConvertForm from "./ConvertForm";
  import ThankYou from "./ThankYou";
  import SendError from "./SendError";

  import {
    LoadingSpinner
  } from "@/components/Elements";

  export default {
    name: "QuoteDetails",
    components: {
      QuoteNotFound,
      QuoteHeader,
      QuoteDetailsGrid,
      ConvertForm,
      ThankYou,
      SendError,
      LoadingSpinner
    },
    computed: {
      ...mapGetters([
        "user",
        "getContentItem",
        "hasPermission",
        "activeAccountId"
      ])
    },
    props: {
      quoteNumber: {
        type: String,
        required: true
      }
    },
    data: () => ({
      details: null,
      isBusy: true,
      notFound: false,
      showForm: false,
      showThankYou: false,
      showSendFailure: false,
      errorMessage: null
    }),
    mounted() {
      this.fetchDetails();
    },
    methods: {
      fetchDetails: function() {
        const args = {
          accountId: this.activeAccountId,
          userId: this.user.UserId,
          quoteNumber: this.quoteNumber
        };

        return QuoteService.getQuoteDetail(args)
          .then(results => {
            this.details = results.data;
          })
          .catch(err => {
            ErrorLogService.LogException(err);
          })
          .finally(() => {
            this.isBusy = false;
            if (!this.details) {
              this.notFound = true;
            }
          });
      },

      getHeaderData: function() {
        return {
          ...this.details,
          accountId: this.activeAccountId,
          userId: this.user.UserId,
          showForm: this.handleShowForm
        };
      },

      getFormData: function() {
        return {
          params: {
            accountId: this.activeAccountId,
            userId: this.user.UserId
          },
          formData: {
            QuoteNumber: this.details.QuoteNumber,
            UserFullName: this.user.FullName,
            UserEmail: this.user.Email
          },
          hideForm: this.handleHideForm,
          showThankYou: this.handleShowThankYou,
          showSendFailure: this.handleShowSendFailure
        };
      },

      getGridDetails: function() {
        return {
          ...this.details
        };
      },

      handleShowForm: function() {
        this.showForm = true;
      },

      handleHideForm: function() {
        this.showForm = false;
      },

      handleShowThankYou: function() {
        this.showForm = false;
        this.showThankYou = true;
      },

      handleShowSendFailure: function(errorMessage) {
        this.showForm = false;
        this.showSendFailure = true;
        this.errorMessage = errorMessage;
      }
    }
  };
</script>

<style lang="scss">
#quote-details {
  .muted {
    color: $gray;
  }

  .header-section {
    .detail-bubble {
      padding: 1rem;
      border: 1px solid $light-gray;
      border-radius: 10px;
      background-color: $background-gray;
    }
  }

  tfoot {
    td {
      text-align: right;

      .inline-label {
        margin-right: 1.5rem;
      }

      .currency-text {
        display: inline-block;
        width: 65px;
      }
    }

    .row-total {
      td {
        font-weight: bold;
      }
    }
  }

  .convert-to-order-form {
    max-width: 600px;
    margin: 1rem auto;
  }

  .element-loading {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5rem;
  }
}
</style>
